import { Button } from '../../Button/Button';

export interface DotProps {
  isSelected: boolean;
  onClickHandler: () => void;
  ariaLabel: string;
}

export const Dot = ({ isSelected, onClickHandler, ariaLabel }: DotProps) => (
  <Button
    className="bg-color-transparent hover:bg-color-transparent relative flex h-[30px] w-[30px] cursor-pointer items-center justify-center border-0 p-0 outline-0"
    variant="icon-flat"
    onClick={() => onClickHandler()}
    aria-label={ariaLabel}
    aria-current={isSelected}
  >
    <div
      className={`${isSelected ? 'bg-color-carousel-dot-selected' : 'bg-color-carousel-dot hover:bg-color-grey'} border-color-carousel-dot-selected transition-background-color-[150ms] h-[14px] w-[14px] rounded-full border`}
    />
  </Button>
);
